import React from 'react';
import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-museum-black text-white pt-24 pb-12 border-t border-gray-900" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20" data-id="element-97">
          {/* Brand Column */}
          <div data-id="element-98">
            <div className="flex items-center gap-3 mb-8" data-id="element-99">
              <div className="h-10 w-10 border-l-[3px] border-b-[3px] border-white flex items-end justify-start p-1" data-id="element-100">
                <div className="h-3 w-3 border-t-[3px] border-r-[3px] border-white" data-id="element-101"></div>
              </div>
              <div className="flex flex-col leading-none" data-id="element-102">
                <span className="font-sans font-black text-lg tracking-widest text-white" data-id="element-103">
                  MUSEUM
                </span>
                <span className="font-sans font-bold text-xs tracking-widest text-white/60" data-id="element-104">
                  STORE PRODUCTS
                </span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-8 font-medium max-w-xs" data-id="element-105">
              Manufacturers of short-run, custom products for the Museum, Gift &
              Souvenir Retail markets. Proudly made in the USA.
            </p>
            <div className="flex space-x-6" data-id="element-106">
              <a href="#" className="text-white hover:text-museum-blue transition-colors" data-id="element-107">
                <Instagram className="w-6 h-6 stroke-[1.5px]" data-id="element-108" />
              </a>
              <a href="#" className="text-white hover:text-museum-blue transition-colors" data-id="element-109">
                <Facebook className="w-6 h-6 stroke-[1.5px]" data-id="element-110" />
              </a>
              <a href="#" className="text-white hover:text-museum-blue transition-colors" data-id="element-111">
                <Linkedin className="w-6 h-6 stroke-[1.5px]" data-id="element-112" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-113">
            <h4 className="text-lg font-serif font-bold mb-8 text-white tracking-wide" data-id="element-114">
              Quick Links
            </h4>
            <ul className="space-y-4 text-sm text-gray-400 font-medium" data-id="element-115">
              <li data-id="element-116">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-117">
                  <span className="w-1.5 h-1.5 bg-museum-blue opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-118"></span>
                  Home
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-120">
                  <span className="w-1.5 h-1.5 bg-museum-blue opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-121"></span>
                  About Us
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-123">
                  <span className="w-1.5 h-1.5 bg-museum-blue opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-124"></span>
                  Custom Products
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-126">
                  <span className="w-1.5 h-1.5 bg-museum-blue opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-127"></span>
                  Fox & Chave
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-129">
                  <span className="w-1.5 h-1.5 bg-museum-blue opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-130"></span>
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-131">
            <h4 className="text-lg font-serif font-bold mb-8 text-white tracking-wide" data-id="element-132">
              Contact Us
            </h4>
            <ul className="space-y-5 text-sm text-gray-400 font-medium" data-id="element-133">
              <li className="flex items-start gap-4" data-id="element-134">
                <MapPin className="w-5 h-5 text-museum-blue shrink-0" data-id="element-135" />
                <span data-id="element-136">
                  123 Museum Way,
                  <br data-id="element-137" />
                  Arts District, MA 02110
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-138">
                <Phone className="w-5 h-5 text-museum-blue shrink-0" data-id="element-139" />
                <span data-id="element-140">(555) 123-4567</span>
              </li>
              <li className="flex items-center gap-4" data-id="element-141">
                <Mail className="w-5 h-5 text-museum-blue shrink-0" data-id="element-142" />
                <span data-id="element-143">hello@museumstoreproducts.com</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-144">
            <h4 className="text-lg font-serif font-bold mb-8 text-white tracking-wide" data-id="element-145">
              Stay Updated
            </h4>
            <p className="text-gray-400 text-sm mb-6 font-medium" data-id="element-146">
              Subscribe to our newsletter for new product announcements.
            </p>
            <form className="flex flex-col gap-3" data-id="element-147">
              <input type="email" placeholder="Enter your email" className="bg-black border-2 border-gray-800 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-white text-sm font-medium placeholder:text-gray-600 transition-colors" data-id="element-148" />
              <button className="bg-white text-museum-black px-4 py-3 rounded-sm text-sm font-bold uppercase tracking-wide hover:bg-museum-blue hover:text-white transition-colors" data-id="element-149">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-150">
          <p data-id="element-151">
            &copy; {new Date().getFullYear()} Museum Store Products. All rights
            reserved.
          </p>
          <div className="flex gap-8" data-id="element-152">
            <a href="#" className="hover:text-white transition-colors" data-id="element-153">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-154">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}